import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // 다국어 지원 초기화
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// 🚀 PWA - Service Worker 등록 (현재 비활성화)
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('/service-worker.js')
//       .then((registration) => {
//         console.log('✅ Service Worker 등록 성공:', registration.scope);

//         // 업데이트 확인
//         registration.addEventListener('updatefound', () => {
//           const newWorker = registration.installing;
//           console.log('🔄 새로운 Service Worker 발견');

//           newWorker.addEventListener('statechange', () => {
//             if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
//               console.log('📢 새 버전 사용 가능! 새로고침하세요.');
//               // 선택사항: 사용자에게 알림 표시
//               if (window.confirm('새 버전이 있습니다. 새로고침하시겠습니까?')) {
//                 window.location.reload();
//               }
//             }
//           });
//         });
//       })
//       .catch((error) => {
//         console.error('❌ Service Worker 등록 실패:', error);
//       });
//   });
// }
